import { Component, NgModule, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterModule } from '../footer/footer';
import { HeaderModule } from '../header/header';

import {MatInputModule} from '@angular/material/input';
import {FormsModule} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { DialogCreateRoom } from './createRoom';

import { FeaturesLandingModule } from '../features-landing/features-landing';
import { StepsLandingModule } from '../steps-landing/steps-landing';
import { PricingLandingModule } from '../pricing-landing/pricing-landing';


import { AppRoutingModule } from '../app-routing.module';
import { RouterModule, Router } from '@angular/router';

//import { HttpClient } from '@angular/common/http';

declare var ScrollReveal : any;
declare var anime : any;
declare var gtag : any;

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.html',
  styleUrls: ['./homepage.scss']
})
export class Homepage implements AfterViewInit {

    public noCodeSpecified = false;
    public roomCode =  '';
    public doAnalytics = false;

    constructor(public dialog: MatDialog) {}

    public toggleModal(openInNewTab = false) {

      let dialogRef = this.dialog.open(DialogCreateRoom);
      //dialogRef.componentInstance.text = 'delete topic';

      dialogRef.afterClosed().subscribe(result => {
        if(result == null)
          return;

        if (result[0] == 'OK') {
          let email = result[1]
          console.log('create room, email: ' + email)
          this.createNewRoom(email, openInNewTab)
        }
      });
      
    }

    ngAfterViewInit() {
        //console.log('after view init')
        console.log("test");
    
        (function () {
          const doc = document.documentElement
        
          doc.classList.remove('no-js')
          doc.classList.add('js')
        
          // Reveal animations
          //if (document.body.classList.contains('has-animations')) {
            /* global ScrollReveal */
            const sr = ScrollReveal()// = window.sr = ScrollReveal()
        
            sr.reveal('.feature, .testimonial', {
              duration: 600,
              distance: '50px',
              easing: 'cubic-bezier(0.5, -0.01, 0, 1.005)',
              origin: 'bottom',
              interval: 100
            })
        
            /* global anime */
            const heroAnimation = anime.timeline({ autoplay: false })
            const strokedElement = document.querySelector('.stroke-animation')
        
            strokedElement.setAttribute('stroke-dashoffset', anime.setDashoffset(strokedElement))
        
            heroAnimation.add({
              targets: '.stroke-animation',
              strokeDashoffset: {
                value: 0,
                duration: 2000,
                easing: 'easeInOutQuart'
              },
              strokeWidth: {
                value: [0, 2],
                duration: 2000,
                easing: 'easeOutCubic'
              },
              strokeOpacity: {
                value: [1, 0.5],
                duration: 1000,
                easing: 'easeOutCubic',
                delay: 2000
              },
              fillOpacity: {
                value: [0, 1],
                duration: 500,
                easing: 'easeOutCubic',
                delay: 1300
              }
            }).add({
              targets: '.fadeup-animation',
              offset: 1300, // Starts at 1300ms of the timeline
              translateY: {
                value: [100, 0],
                duration: 1500,
                easing: 'easeOutElastic',
                delay: function (el, i) {
                  return i * 150
                }
              },
              opacity: {
                value: [0, 1],
                duration: 200,
                easing: 'linear',
                delay: function (el, i) {
                  return i * 150
                }
              }
            }).add({
              targets: '.fadeleft-animation',
              offset: 1300, // Starts at 1300ms of the timeline
              translateX: {
                value: [40, 0],
                duration: 400,
                easing: 'easeOutCubic',
                delay: function (el, i) {
                  return i * 100
                }
              },
              opacity: {
                value: [0, 1],
                duration: 200,
                easing: 'linear',
                delay: function (el, i) {
                  return i * 100
                }
              }
            })
        
            doc.classList.add('anime-ready')
            heroAnimation.play()
         // }
        }()) 
      }

    createNewRoom(emailValue, openInNewTab = false) {

      var HttpClient = function () {
        this.get = function (aUrl, aCallback) {
          var anHttpRequest = new XMLHttpRequest();
          anHttpRequest.onreadystatechange = function () {
            if (anHttpRequest.readyState == 4 && anHttpRequest.status == 200)
              aCallback(anHttpRequest.responseText);
          }

          anHttpRequest.open("GET", aUrl, true);
          anHttpRequest.send(null);
        }
      }

      // http call to v2 api

      //var emailValue = ''//emailInput.value;
      //console.log(emailValue);

      var client = new HttpClient();
      var masterAPI = 'https://api.talkmath.org/v20';//'http://46.101.189.175:3000';
      var addr = masterAPI + '/startNewServer?email=' + emailValue;

      client.get(addr, function (response) {
        var res = JSON.parse(response)
        var teacher = res.coach;

        /* send gtag event */
        if(this.doAnalytics == true)
          gtag('event', 'website', { event_category: 'create', event_action: emailValue, event_label: teacher });

        var roomAddress = 'https://www.talkmath.org/roomY/' + teacher; //+ res.address;//'http://46.101.189.175/?N=' + teacher;

        if(openInNewTab == false) {
          window.location.href = roomAddress;//'http://46.101.189.175/?N=' + teacher;//roomAddress;
        }
        else {
          window.open(roomAddress,'_blank');
        }
      }.bind(this));
    }

		showInput() {
		}
	
		/*joinClicked() {
			if (x.style.display === "none") {
				x.style.display = "block";
				xInput.focus();
			} else {
	
				 //send gtag event 
				//gtag('event', 'website', { event_category: 'join', event_action: 'join', event_label: xInput.value });
	
				if (xInput.value != '') {
					window.location.href = 'https://talkmath.org/roomX/' + xInput.value;//'http://46.101.189.175/?N=' + xInput.value;
				}
			}
		}*/
	
		public joinRoom() {
            if(this.roomCode == '')
            {
                this.noCodeSpecified = true;
            }
            else
            {
               /* send gtag event */
               if(this.doAnalytics == true)
                gtag('event', 'website', { event_category: 'join', event_action: 'join', event_label: this.roomCode });

                this.noCodeSpecified = false;
                window.location.href = 'https://talkmath.org/roomY/' + this.roomCode;
            }
            
            console.log('noCodeSpecified: ' + this.noCodeSpecified)
			// ask for code
			//this.joinClicked();
		}
	
		sendToRoom(code) {
		}
}

@NgModule({
  imports: [FormsModule,CommonModule,FooterModule,HeaderModule,MatInputModule, MatButtonModule, MatIconModule, FeaturesLandingModule, StepsLandingModule, PricingLandingModule, RouterModule],
  exports: [Homepage],
  declarations: [Homepage],
})
export class HomepageModule {}